import { EnvVars } from '../constants/EnvConfig';

export const GOOGLE_API_PROXY_URL = `${EnvVars.apiUrl}address`;

/**
 * @param {string} address
 * @returns {object} location
 * @returns {number} location.lat
 * @returns {number} location.lng
 * @example
 * const location = await geocode('1600 Amphitheatre Parkway, Mountain View, CA');
 * console.log(location);
 * // {
 * //   lat: 37.4224764,
 * //   lng: -122.0842499,
 * // }
 */
export const geocode = async (address) => {
  const { googlePlacesApiKey } = EnvVars;

  try {
    const url = new URL(GOOGLE_API_PROXY_URL);
    url.searchParams.append('address', address);
    url.searchParams.append('key', googlePlacesApiKey);

    const urlWithRemovedTrailingSlash = url.href.replace('/?', '?');
    const res = await fetch(urlWithRemovedTrailingSlash);
    const location = (await res.json()).results[0].geometry.location;

    return location;
  } catch (error) {
    console.error('error', error);
  }
};
